export default "__VITE_ASSET__c7855ae8__"